import { useState } from "react";
import { BoardTask } from "./BoardTask";
import Modal from "../../../components/Modal/Modal";
import { boardActions } from "../../../actions/boards";
import { useGlobalUserState } from "../../../stores/user";
import Plus from "../../../assets/icons/Plus";

const { boardColumns } = require("../../../misc/constants");

export const BoardColumn = ({ board, type, tasks, setTrigger }) => {
  const boardId = board.id;
  const userState = useGlobalUserState();
  const userObj = userState.get();
  const [taskName, setTaskName] = useState("");
  const [taskDescription, setTaskDescription] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const createTask = async () => {
    const result = await boardActions.createBoardTask(
      boardId,
      taskName,
      taskDescription
    );
    if (result.success) {
      setTrigger((t) => t + 1);
      setTaskName("");
      setTaskDescription("");
      setModalVisible(false);
    }
  };

  console.log(userObj);

  const meta = boardColumns.find((c) => c.label === type);
  if (!!meta) {
    return (
      <div className={`${board.bg} rounded-[20px] p-4 flex flex-col`}>
        <p className={`text-[#1A1A1A] text-[20px] mb-6`}>{meta.label}</p>
        {tasks
          .filter((t) => t.status === type)
          .map((t) => (
            <BoardTask task={t} setTrigger={setTrigger} />
          ))}
        {type === "В ожидании" && (
          <button
            className="flex flex-row items-center justify-center cursor-pointer my-4 rounded-lg py-[15px] border border-[#5F6B88]"
            onClick={() => setModalVisible(true)}
          >
            <Plus additionalStyle="text-gray-600" />
            <span className="ml-2 text-[15px] font-semibold leading-[18px] text-[#5F6B88]">
              Добавить задачу
            </span>
          </button>
        )}
        <Modal
          dimensions="w-2/5 rounded-[10px] p-7"
          visible={modalVisible}
          setVisible={setModalVisible}
          additionalClassName="!w-[30vw]"
        >
          <div className="flex flex-col">
            <div className="flex flex-row justify-center">
              <p className="text-lg text-black font-semibold">Создать задачу</p>
            </div>
            <p className="text-sm font-semibold text-black">Название</p>
            <input
              className="border border-black mt-1.5 rounded-md shadow-container-1 text-black py-3 px-2"
              value={taskName}
              onChange={(e) => setTaskName(e.target.value)}
            />
            <p className="text-sm font-semibold text-black mt-5">Описание</p>
            <textarea
              className="border border-black mt-1.5 rounded-md shadow-container-1 text-black py-3 px-2"
              value={taskDescription}
              onChange={(e) => setTaskDescription(e.target.value)}
              rows={4}
            />
            <button
              className="bg-[rgba(67,46,118,0.7)] rounded-md mt-6 py-3 text-white"
              onClick={createTask}
            >
              Создать
            </button>
          </div>
        </Modal>
      </div>
    );
  }
};
